import React from 'react';
import { Spinner } from 'react-bootstrap';
import './LoadingPlaceholders.css';

/**
 * Shown while React.lazy() route chunks load. Must be a React element (not a function)
 * passed to <Suspense fallback={...}>.
 */
const RouteLoadingFallback = () => (
  <div className="route-loading-fallback" role="status" aria-live="polite">
    <Spinner animation="border" variant="primary" />
    <p className="route-loading-fallback-text">Loading page…</p>
  </div>
);

export default RouteLoadingFallback;
